import { Appendix } from "../../../../shared/entities/scripts/appendix";
import { Study } from "../../../../shared/entities/scripts/study";

export class WearablesEntity {

    SubjectId: string;
    OverallDays: number;
    StudyId: number;
    SiteNumber: number;
    AppendixId: number;
    Age: number;
    RaceId: number;
    HispanicId: number;
    SexId: number;
    RecoverCohort: number;
    CareEvo: number;

    PercentSyncedOverall: string;
    PercentSyncedBase: string;
    SyncedBase: number;
    PercentSyncedMOI: string;
    SyncedMOI: number;
    PercentSyncedEOI: string;
    SyncedEOI: number;
    PercentSyncedEOS: string;
    SyncedEOS: number;

    NumDay3Nudge: number;
    NumDay7Nudge: number;
    NumDay10Nudge: number;
    TotalNotifyCoord: number;

    StudyDisplay: string;
    AppendixDisplay: string;
    PercentSyncedOverallValue: number;
    PercentSyncedBaseValue: number;
    PercentSyncedMOIValue: number;
    PercentSyncedEOIValue: number;
    PercentSyncedEOSValue: number;
    AgeRange: number;

    SyncedBaseDaysValue: number;
    SyncedMOIDaysValue: number;
    SyncedEOIDaysValue: number;
    SyncedEOSDaysValue: number;

    CountSyncedBase: string;
    CountSyncedMOI: string;
    CountSyncedEOI: string;
    CountSyncedEOS: string;

    BaseTargetDate: string;
    MOITargetDate: string;
    EOITargetDate: string;
    EOSTargetDate: string;

    initialize(): void {
        this.StudyDisplay = Study.GetStudyName(this.StudyId);
        this.AppendixDisplay = Appendix.GetAppendixName(this.AppendixId);

        this.PercentSyncedOverallValue = Number.parseFloat(this.PercentSyncedOverall);
        this.PercentSyncedBaseValue = Number.parseFloat(this.PercentSyncedBase);
        this.PercentSyncedMOIValue = Number.parseFloat(this.PercentSyncedMOI);
        this.PercentSyncedEOIValue = Number.parseFloat(this.PercentSyncedEOI);
        this.PercentSyncedEOSValue = Number.parseFloat(this.PercentSyncedEOS);

        if (this.Age === -1) {
            this.AgeRange = 3;
        } else if (this.Age <= 45 && this.Age >= 18) {
            this.AgeRange = 0;
        } else if (this.Age <= 65 && this.Age > 45) {
            this.AgeRange = 1;
        } else if (this.Age > 65) {
            this.AgeRange = 2;
        }

        this.SyncedBaseDaysValue = Number.parseInt(this.CountSyncedBase);
        this.SyncedMOIDaysValue = Number.parseInt(this.CountSyncedMOI);
        this.SyncedEOIDaysValue = Number.parseInt(this.CountSyncedEOI);
        this.SyncedEOSDaysValue = Number.parseInt(this.CountSyncedEOS);
    }

}